import * as React from 'react';
import { WizardNavIndicatorProps } from './WizardNavBar.types';

export class WizardNavIndicator extends React.PureComponent<WizardNavIndicatorProps> {
  private getClassNames = () => {
    // todo: get npm pkg className and refactor.
    let classNames = 'wizardstepper__step';

    if (this.props.isActive) classNames += ' wizardstepper__step--active';
    if (this.props.isDone || (this.props.isActive && this.props.isThankYouPage))
      classNames += ' wizardstepper__step--done';

    return classNames;
  };

  private getLinkClassNames = () => {
    let classNames = 'wizardstepper__link';
    if (this.props.isThankYouPage) {
      classNames += ' wizardstepper__link--disabled';
    } else {
      if (this.props.currentStep === this.props.thankYouStep) {
        classNames += ' wizardstepper__link--disabled';
      }
    }
    return classNames;
  };

  private onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    if (this.props.currentStep !== this.props.thankYouStep) {
      if (!this.props.isActive && !this.props.isThankYouPage) {
        this.props.onClick(this.props.stepId);
      }

      // if (!this.props.isActive) {
      //   this.props.onClick(this.props.stepId);
      // }
    }
  };

  public render() {
    const { stepId, stepLabel, isDone, isActive, isThankYouPage } = this.props;
    const stepStateString = isDone || (isActive && isThankYouPage) ? 'klart' : 'inte klart';
    return (
      <li className="wizardstepper__li">
        <div className={this.getClassNames()}>
          <a
            onClick={this.onClick}
            href="#"
            className={this.getLinkClassNames()}
            aria-label={`Gå till steg ${stepId + 1}, steget är ${stepStateString}`}></a>
        </div>

        <div className="wizardstepper__label" aria-hidden="true">
          {stepLabel}
        </div>
      </li>
    );
  }
}
